import {
    ResourceDisplayName,
    ResourceDisplayNameWithFetch,
} from 'components/pages/entitlement/resource/ResourceDisplayName'

export { ResourceDisplayName, ResourceDisplayNameWithFetch }
